// Facebook Pixel helper.
// The pixel is NOT loaded unconditionally — it's a marketing cookie under the site's granular
// consent system (src/lib/cookieConsent.ts) and only gets injected once marketing consent is
// granted, via initFacebookPixelIfConsented() below (mounted once in src/App.tsx).
import { hasConsent } from "@/lib/cookieConsent";

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

export const FB_PIXEL_ID = "1260515699589762";

let pixelInitialized = false;

export function initFacebookPixelIfConsented(): void {
  if (pixelInitialized || typeof window === "undefined") return;
  if (!hasConsent("marketing")) return;
  pixelInitialized = true;

  /* eslint-disable */
  (function (f: any, b: Document, e: string, v: string, n: any, t: any, s: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js", undefined, undefined, undefined);
  /* eslint-enable */

  window.fbq?.("init", FB_PIXEL_ID);
  window.fbq?.("track", "PageView");
}

type LeadParams = {
  source?: string;
  type?: string;
  language?: string;
  content_name?: string;
  value?: number;
  currency?: string;
};

export function trackLead(params: LeadParams = {}) {
  try {
    if (typeof window === "undefined" || typeof window.fbq !== "function") return;
    window.fbq("track", "Lead", {
      content_name: params.content_name ?? params.source ?? "lead_form",
      content_category: params.type,
      source: params.source,
      language: params.language,
      ...(params.value != null ? { value: params.value, currency: params.currency ?? "EUR" } : {}),
    });
  } catch {
    /* no-op */
  }
}

export function trackEvent(event: string, params?: Record<string, unknown>) {
  try {
    if (typeof window === "undefined" || typeof window.fbq !== "function") return;
    window.fbq("track", event, params ?? {});
  } catch {
    /* no-op */
  }
}
